import { IconProps } from "../interface";
import { IconColours } from "../interface";

export const Refresh: React.FC<IconProps> = ({
    size,
    className,
    title = "refresh",
    ariaHidden,
    colour = IconColours.black,
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 12 13"
        fill="none"
        role="img"
        aria-hidden={ariaHidden}
        focusable={!ariaHidden}
        className={className}
    >
        <title>{title}</title>
        <path
            data-testid="path"
            d="M6 12.5C4.325 12.5 2.90625 11.9187 1.74375 10.7563C0.58125 9.59375 0 8.175 0 6.5C0 4.825 0.58125 3.40625 1.74375 2.24375C2.90625 1.08125 4.325 0.5 6 0.5C6.8625 0.5 7.6875 0.678125 8.475 1.03438C9.2625 1.39062 9.9375 1.9 10.5 2.5625V1.25C10.5 1.0375 10.5719 0.859375 10.7156 0.715625C10.8594 0.571875 11.0375 0.5 11.25 0.5C11.4625 0.5 11.6406 0.571875 11.7844 0.715625C11.9281 0.859375 12 1.0375 12 1.25V5C12 5.2125 11.9281 5.39062 11.7844 5.53438C11.6406 5.67812 11.4625 5.75 11.25 5.75H7.5C7.2875 5.75 7.10938 5.67812 6.96563 5.53438C6.82188 5.39062 6.75 5.2125 6.75 5C6.75 4.7875 6.82188 4.60938 6.96563 4.46562C7.10938 4.32187 7.2875 4.25 7.5 4.25H9.9C9.5 3.55 8.95312 3 8.25937 2.6C7.56562 2.2 6.8125 2 6 2C4.75 2 3.6875 2.4375 2.8125 3.3125C1.9375 4.1875 1.5 5.25 1.5 6.5C1.5 7.75 1.9375 8.8125 2.8125 9.6875C3.6875 10.5625 4.75 11 6 11C6.85 11 7.62813 10.7844 8.33438 10.3531C9.04063 9.92188 9.5875 9.34375 9.975 8.61875C10.075 8.44375 10.2156 8.32188 10.3969 8.25313C10.5781 8.18438 10.7625 8.18125 10.95 8.24375C11.15 8.30625 11.2937 8.4375 11.3813 8.6375C11.4688 8.8375 11.4625 9.025 11.3625 9.2C10.85 10.2 10.1188 11 9.16875 11.6C8.21875 12.2 7.1625 12.5 6 12.5Z"
            fill={colour}
        />
    </svg>
);
